/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  GetLodgingDoorQueryResponse,
  GetLodgingDoorPathParams,
  GetLodgingDoor404,
} from '../types/GetLodgingDoor'

function getGetLodgingDoorUrl({
  lodging_id,
}: {
  lodging_id: GetLodgingDoorPathParams['lodging_id']
}) {
  const res = {
    method: 'GET',
    url: `/api/v1/places/lodging-doors/${lodging_id}/` as const,
  }
  return res
}

/**
 * @summary Get a lodging door
 * {@link /api/v1/places/lodging-doors/:lodging_id/}
 */
export async function getLodgingDoor(
  { lodging_id }: { lodging_id: GetLodgingDoorPathParams['lodging_id'] },
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    GetLodgingDoorQueryResponse,
    ResponseErrorConfig<GetLodgingDoor404>,
    unknown
  >({
    method: 'GET',
    url: getGetLodgingDoorUrl({ lodging_id }).url.toString(),
    ...requestConfig,
  })
  return res.data
}
